import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

export interface ItemListingCardModel {
  id: string;
  condition: string;
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  linkHref: string;
  linkText: string;
}

export interface ItemListingCardProps {
  card: ItemListingCardModel;
  descriptionWordLimit?: number;
  titleCharacterLimit?: number;
  titleLineLimit?: number;
  descriptionLineLimit?: number;
}

export const ItemListingContentType = {
  Study: 'study',
  Article: 'article',
  Item: 'item',
} as const;

export type ItemListingContentType =
  (typeof ItemListingContentType)[keyof typeof ItemListingContentType];

export interface ItemListingSitecoreItem {
  id?: string;
  url?: string;
  name?: string;
  displayName?: string;
  fields?: Record<string, unknown>;
}

export interface ItemListingFields {
  title?: Field<string>;
  showingOf?: Field<string>;
  studyList?: ItemListingSitecoreItem[];
  articleList?: ItemListingSitecoreItem[];
  itemList?: ItemListingSitecoreItem[];
  descriptionWordLimit?: Field<number | string>;
  titleCharacterLimit?: Field<number | string>;
  titleLineLimit?: Field<number | string>;
  descriptionLineLimit?: Field<number | string>;
  gradientBackground?: Field<string>;
  enableFilterChip?: Field<boolean>;
}

export interface ItemListingProps extends ComponentProps {
  fields?: ItemListingFields;
  /** Rendering parameters — Droplist `list` is "Study Listing" | "Article Listing" */
  params?: {
    list?: string;
    [key: string]: string | undefined;
  };
}

/** Sitecore Featured Trial shape used by studyList */
export interface StudyListItemFields {
  /** Expanded link object, raw GUID, or null when Droptree target fails to resolve */
  relatedTrial?:
    | string
    | null
    | {
        fields?: {
          featuredTrialImage?: ImageField;
          featuredTrialCondition?: {
            fields?: {
              description?: Field<string>;
            };
          };
          trialTitle?: Field<string>;
          trialDescription?: Field<string>;
        };
      };
  trialCTA?: LinkField;
}

/** Sitecore Article shape used by articleList */
export interface ArticleListItemFields {
  articleConditions?: {
    fields?: {
      description?: Field<string>;
    };
  };
  articleTitle?: Field<string>;
  articleDescription?: Field<string>;
  articleImage?: ImageField;
}

/** Sitecore ItemList shape used by itemList (future) */
export interface GenericItemListFields {
  title?: Field<string>;
  description?: Field<string>;
  image?: ImageField;
  button?: LinkField;
}
